<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>

            <div class="container-fluid mt-5">
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard'
                  },
                  {
                    title: 'Knowledge Base',
                    url: '/#/dashboard/Admin/KnowledgeBaseArchives',
                    active: true
                  }
                ]"></vs-breadcrumb>
                        <div class="frm-title pl-0">
                            <div class="heading mt-3">
                                <h3 class="text-secondary-2 text-center">Knowledge Base</h3>
                                <p>{{clickTrainingTitle}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- new design starts -->
                <div class="row mb-4">
                    <!-- col-md-4 trainings starts -->
                    <div class="col-md-3 mb-3 pr-0">
                        <div class="trainings">
                            <div class="text-center crd-title">
                                <h5>Trainings</h5>
                                <small>
                                    <b>({{ this.trainings.length }} trainings)</b>
                                </small>
                            </div>
                            <!-- Training list starts -->
                            <div class="mb-5">
                                <ul class="mt-4 list-ul">
                                    <!-- li starts -->
                                    <li v-for="(training, index) in trainings" v-bind:key="training.id" class="display-li mb-2 hover-on-li" @click="showMaterials(training.id,training.title); activateTr(training.id);" :class="{ 'active-bg' : active_tr == training.id }">
                                        <div class="d-sm-flex justify-content-between">
                                            <div class="d-sm-flex">
                                                <div class="short-title pr-3">
                                                    <b class="clr-blue">TR{{index+1}}</b>
                                                </div>
                                                <div class="md-title">
                                                    <h6>{{training.title}}</h6>
                                                    <small v-if="
                                (training.startdate != null) &
                                  (training.enddate != null)
                              ">{{ training.startdate }} - {{ training.enddate }}</small>
                                                    <small v-else>Start Date & End Date: Not defined yet.</small>
                                                    <p v-if="training.address != null">
                                                        {{ training.address }}
                                                    </p>
                                                    <p v-else>Address: Not defined yet.</p>
                                                </div>
                                            </div>
                                            <div class="align-self-center">
                                                <i class="material-icons large clr-blue" style>play_arrow</i>
                                            </div>
                                        </div>
                                    </li>
                                    <!-- li ends -->
                                </ul>
                            </div>
                            <!-- Training list ends -->
                            <!-- ----------------------------------- -->
                        </div>
                    </div>
                    <!-- col-md-4 trainings ends -->
                    <div class="col-md-9">
                        <div class="clr-border-blue">
                            <b-card no-body style="border:none !important;">
                                <b-tabs pills card vertical>
                                    <b-tab :title-item-class="'tab-title-class'" disabled title="Filter by" style></b-tab>
                                    <b-tab title="Show All" active>
                                        <b-card-text>
                                            <div class="col-sm-12">
                                                <div class="tab-item">
                                                    <vs-list>
                                                        <vs-list-header title="All" color="success"></vs-list-header>
                                                        <vs-list-item v-for="(all, index) in allMaterialArr" :title="all.title" :subtitle="all.createdAt | formatDate" class="hvr" v-bind:key="index">
                                                            <span v-if="all.fileType != 'Weblink'">
                                                                <a :href="BASEPATHDYNAMIC + '/' + all.uploadfile" target="_blank">
                                                                    <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                                                                </a>
                                                            </span>
                                                            <span v-else>
                                                                <a :href="'//' + all.link" target="_blank">
                                                                    <i class="material-icons" style="font-size:28px;color:#4285f4">link</i>
                                                                </a>
                                                            </span>
                                                        </vs-list-item>
                                                    </vs-list>
                                                </div>
                                            </div>
                                        </b-card-text>
                                    </b-tab>
                                    <b-tab title="Presentations" @click="loadMaterials('PPT')">
                                        <b-card-text>
                                            <div class="col-sm-12">
                                                <div class="tab-item">
                                                    <vs-list>
                                                        <vs-list-header title="Presentation(s)" color="success"></vs-list-header>
                                                        <vs-list-item v-for="(ppt, ppindex) in PPTFilter" :title="ppt.title" :subtitle="ppt.createdAt | formatDate" class="hvr" v-bind:key="ppindex">
                                                            <a :href="BASEPATHDYNAMIC + '/' + ppt.uploadfile" target="_blank">
                                                                <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                                                            </a>
                                                        </vs-list-item>
                                                    </vs-list>
                                                </div>
                                            </div>
                                        </b-card-text>
                                    </b-tab>
                                    <b-tab title="Word" @click="loadMaterials('Word')">
                                        <b-card-text>
                                            <div class="col-sm-12">
                                                <div class="tab-item">
                                                    <vs-list>
                                                        <vs-list-header title="Word Documents" color="success"></vs-list-header>
                                                        <vs-list-item v-for="(training, index) in WordFilter" :title="training.title" :subtitle="training.createdAt | formatDate" class="hvr" v-bind:key="index">
                                                            <a :href="
                                    BASEPATHDYNAMIC + '/' + training.uploadfile
                                  " target="_blank">
                                                                <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                                                            </a>
                                                        </vs-list-item>
                                                    </vs-list>
                                                </div>
                                            </div>
                                        </b-card-text>
                                    </b-tab>
                                    <b-tab title="PDF" @click="loadMaterials('PDF')">
                                        <b-card-text>
                                            <div class="col-sm-12">
                                                <div class="tab-item">
                                                    <vs-list>
                                                        <vs-list-header title="PDF" color="success"></vs-list-header>
                                                        <vs-list-item v-for="(training, index) in PDFFilter" :title="training.title" :subtitle="training.createdAt | formatDate" class="hvr" v-bind:key="index">
                                                            <a :href="
                                    BASEPATHDYNAMIC + '/' + training.uploadfile
                                  " target="_blank">
                                                                <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                                                            </a>
                                                        </vs-list-item>
                                                    </vs-list>
                                                </div>
                                            </div>
                                        </b-card-text>
                                    </b-tab>
                                    <b-tab title="Html Links" @click="loadMaterials('Weblink')">
                                        <b-card-text>
                                            <div class="col-sm-12">
                                                <div class="tab-item">
                                                    <vs-list>
                                                        <vs-list-header title="Html Links" color="success"></vs-list-header>
                                                        <vs-list-item v-for="(training, index) in HtmlFilter" :title="training.title" :subtitle="training.createdAt | formatDate" class="hvr" v-bind:key="index">
                                                            <a :href="'//' + training.link" target="_blank">
                                                                <i class="material-icons" style="font-size:28px;color:#4285f4">link</i>
                                                            </a>
                                                        </vs-list-item>
                                                    </vs-list>
                                                </div>
                                            </div>
                                        </b-card-text>
                                    </b-tab>
                                    <b-tab title="Videos" @click="loadMaterials('Video')">
                                        <b-card-text>
                                            <div class="col-sm-12">
                                                <div class="tab-item">
                                                    <vs-list>
                                                        <div class="row mb-3">
                                                            <div class="col-lg-4 mb-1" v-for="(training, index) in VideosFilter" v-bind:key="index">
                                                                <!-- video player starts -->
                                                                <div class="vd-crd">
                                                                    <video controls>
                                                                        <source :src="
                                          BASEPATHDYNAMIC +
                                            '/' +
                                            training.uploadfile
                                        " />
                                                                        <source :src="
                                          BASEPATHDYNAMIC +
                                            '/' +
                                            training.uploadfile
                                        " />
                                                                        Your browser does not support HTML5 video.
                                                                    </video>
                                                                    <h6 class="vid-title">
                                                                        {{ training.title }}
                                                                    </h6>
                                                                </div>
                                                                <!-- video player ends -->
                                                            </div>
                                                        </div>
                                                    </vs-list>
                                                </div>
                                            </div>
                                        </b-card-text>
                                    </b-tab>
                                    <b-tab title="Images" @click="loadMaterials('Image')">
                                        <b-card-text>
                                            <div class="col-sm-12">
                                                <div class="tab-item">
                                                    <vs-list>
                                                        <vs-list-header title="All" color="success"></vs-list-header>
                                                        <vs-list-item v-for="(image, index) in imageFilter" :title="image.title" :subtitle="image.createdAt | formatDate" class="hvr" v-bind:key="index">
                                                            <a :href="BASEPATHDYNAMIC + '/' + image.uploadfile" target="_blank">
                                                                <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                                                            </a>
                                                        </vs-list-item>
                                                    </vs-list>
                                                </div>
                                            </div>
                                        </b-card-text>
                                    </b-tab>
                                    <b-tab title="Certificates" @click="loadMaterials('Certificate')">
                                        <b-card-text>
                                            <div class="col-sm-12">
                                                <div class="tab-item">
                                                    <vs-list>
                                                        <vs-list-header title="All" color="success"></vs-list-header>
                                                        <vs-list-item v-for="(cert, index) in certFilter" :title="cert.title" :subtitle="cert.createdAt | formatDate" class="hvr" v-bind:key="index">
                                                            <a :href="BASEPATHDYNAMIC + '/' + cert.uploadfile" target="_blank">
                                                                <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                                                            </a>
                                                        </vs-list-item>
                                                    </vs-list>
                                                </div>
                                            </div>
                                        </b-card-text>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                            <!-- <vs-pagination :total="30" v-model="currentx"></vs-pagination> -->
                        </div>
                    </div>
                </div>
                <!-- new design ends -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";


export default {
    data: () => ({
        isSidebar: false,
        trainings: [],
        allMaterialArr: [],
        clickTrainingTitle: '',
        trainingId: "",
        trainingCode: "",
        BASEPATHDYNAMIC: "",
        filterResult: [],
        WordFilter: [],
        PDFFilter: [],
        HtmlFilter: [],
        VideosFilter: [],
        PPTFilter: [],
        imageFilter: [],
        certFilter: [],
        ReferenceMaterial: [],
        active_tr: 0,
    }),
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    },
    watch: {
        trainingId() {

        }
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;

        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/get/all/training/" +
                JSON.parse(localStorage.getItem("currentUser")).id +
                ""

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainings = response.data;
                this.trainingId = this.trainings[0].id;
                this.clickTrainingTitle = this.trainings[0].title;
                this.trainingMaterialsLoad(this.trainingId);
                this.activateTr(this.trainingId);
            });
    },
    methods: {
        // for active li's
        activateTr: function activateTr(id) {
            this.active_tr = id;
        },
        showMaterials: function showMaterials(trId, ttitle) {
            this.clickTrainingTitle = '';
            this.trainingId = trId;
            this.clickTrainingTitle = ttitle;
            this.trainingMaterialsLoad(trId);
        },
        trainingMaterialsLoad: function trainingMaterialsLoad(id) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainingmaterils/knowledgebase/get/" +
                    id +
                    ""

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.allMaterialArr = response.data;
                });
        },
        loadMaterials: function loadMaterials(type) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainingmaterils/type/get/" +
                    type +
                    "" +
                    "/" +
                    this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (type === "Word") {
                        this.WordFilter = response.data;
                    } else if (type === "PDF") {
                        this.PDFFilter = response.data;
                    } else if (type === "Weblink") {
                        this.HtmlFilter = response.data;
                    } else if (type === "Video") {
                        this.VideosFilter = response.data;
                    } else if (type === "PPT") {
                        this.PPTFilter = response.data;
                    } else if (type === "Image") {
                        this.imageFilter = response.data;
                    } else if (type === "Certificate") {
                        this.certFilter = response.data;
                    }
                });
        },

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {

            this.$vs.loading.close();
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        successUpload() {
            this.$vs.notify({
                color: "success",
                title: "Upload Success",
                text: "Files have been Uploaded, consectetur"
            });
        }
        // togglemenu() {
        //   $("#wrapper").toggleClass("toggled");
        // }
    }
};
</script>

<style scoped>
ul li {
    cursor: pointer;
}

a {
    cursor: pointer;
}

#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.vs-avatar--text {
    text-transform: uppercase !important;
}

/* .vs-card--header {
 background: #cccccc7a;
} */
.vs-card--content {
    margin-bottom: 0px !important;
}

.kb-box {
    width: 100%;
    height: auto;
    background: #fff;
    /* border-radius: 8px; */
    margin-bottom: 20px !important;
    display: block;
    -webkit-box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    /* padding:5px; */
}

.title-header {
    /* border-radius: 8px; */
    /* margin-bottom: 10px; */
    display: block;
    /* -webkit-box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
  box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
  -webkit-transition: all .3s ease;
  transition: all .3s ease; */
    background: #cccccc7a;
    padding: 5px;
    border-left: 3px solid #06a6e0;
}

.body-box {
    padding: 15px 5px;
}

.footer {
    padding: 15px 5px;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.trainings {
    background-color: #e6f4ff;
    border: 2px solid #9fdcf7;
    min-height: 85vh;
    max-height: 85vh;
    overflow: auto;
}

.clr-border-blue {
    min-height: 85vh;
    max-height: 85vh;
    overflow: auto;
}

.clr-blue {
    color: #00a4ea;
}

.clr-border-blue {
    border: 2px solid #9fdcf7;
}

b {
    color: #080808;
    font-size: 13px;
}

.bg-clr-blue {
    background-color: #e6f4ff;
    padding: 10px;
}

.list-ul {
    padding: 5px;
}

/* .display-li {
  display: flex;
  justify-content: space-between;
} */
.short-title {
    padding: 8px 4px 8px 12px;
}

.md-title {
    padding: 0px 4px;
}

.mt-10 {
    margin-top: 78px;
}

.text-secondary-2 {
    color: #6c757d !important;
}

.active-bg {
    background: #eedfd1 !important;
}

.hover-on-li:hover {
    background: #eedfd1 !important;
}
</style>
